<template>
  <div>
    <div class='gPageBorder pushObjectDetail'>
      <div class="title">{{ titleName }}</div>
      <el-row :gutter="20" class="detail">
        <el-col :span="6"><label>版本号:</label>{{info['version']||''}}</el-col>
        <el-col :span="6"><label>文件大小:</label>{{info.size||''}}</el-col>
        <el-col :span="6"><label>渠道商:</label>{{info['mechanismName']}}</el-col>
        <el-col :span="6"><label>上传时间:</label>{{info.opetime||''}}</el-col>
      </el-row>
      <el-row :gutter="20" class="mark">
        <el-col :span="20"><label>OTA描述:</label>{{info['memo']||''}}</el-col>
      </el-row>
    </div>

    <div class='gTopMg gPageBorder' v-loading='pLoading'>
      <p class='gPTitle'>{{$t('app_pushHistory')}}</p>
      <div class="subTitle_buttonBar">
        <el-button size="small" @click="jumpToPush()">添加推送</el-button>
        <el-button size="small">批量还原({{multipleSelection.length || 0}})</el-button>
      </div>
      <div id=''>
        <el-table
          @row-click='cellClick'
          @selection-change="handleSelectionChange"
          :data="tableData"
          border
          tooltip-effect="dark"
          style="width: 100%">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            align=center
          prop='mechanismName'
          :label="$t('app_distributor')"
          width="">
          </el-table-column>
          <el-table-column
            align=center
          prop="nums"
          :label="$t('app_deviceNum')"
          width="">
          </el-table-column>
          <el-table-column
            align=center
          prop="pushTime"
          :label="$t('app_pushTime')"
          width=''>
          </el-table-column>
          <el-table-column
            prop="operate"
            align=center
          :label="$t('app_operate')"
          width='80'>
          <template slot-scope='scope'>
            <!-- <el-button type='text' @click='deleteRow(scope.row)'>{{$t('app_clear')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_clear')" placement="top">
              <el-button type='text' ><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>
          </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <paging :rdata="pagingData" :action="pAction"></paging>
      <!-- 分页 END -->
      <div style="height:1px;margin-bottom: 20px;"></div>
    </div>

  </div>
</template>

<style>
</style>

<script>
  import MPage from '@/components/global/paging.vue'
  export default{
    data () {
      return {
        info: '',
        titleName: '',
        pLoading: 0,
        pagingData: {
          total: 0,
          pageSize: 20,
          currentPage: 1
        },
        multipleSelection: [],
        tableData: []
      }
    },
    components: {
      paging: MPage
    },
    computed: {
    },
    methods: {
      handleSelectionChange (val) {
        this.multipleSelection = val
      },
      pAction () {

      },
      cellClick () {

      },
      jumpToPush () {
        //任务类型:1.应用推送； 2.OTA推送； 3.ROM推送； 4.固件推送； 5.广告推送； 6.动画推送； 10.launcher推送。
        location.hash = '#/romPush/history/push/2'
      }
    },
    mounted () {
      let that = this
      this.info = that.$getWObj().otaPushInfo
      this.titleName = that.info.name || ''
    }
  }
</script>



// WEBPACK FOOTER //
// romPushHistory.vue?5fd01fea